// extracted by mini-css-extract-plugin
export var active = "_tg-1";
export var circle = "_tg-0";
export var completed = "_tg-2";
export var connector = "_tg-4";
export var connectorCompleted = "_tg-7";
export var connectorSpacer = "_tg-5";
export var iconStrokeOverride = "_tg-8";
export var labelContainer = "_tg-6";
export var pending = "_tg-3";